import { NO_ESCAPE_OPTIONS } from "@src/raya-lucaria/i18n/interpolation";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export function useReorderLabels() {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      instructions: t("reorderInstructions"),
      roleDescription: t("reorderRoleDescription"),
      saving: t("reorderSaving"),
      saved: t("reorderSaved"),
      moveUp: t("reorderMoveUp"),
      moveDown: t("reorderMoveDown"),
      pickedUp: (name: string, position: number, total: number) =>
        t("reorderPickedUp", { name, position, total, ...NO_ESCAPE_OPTIONS }),
      moved: (name: string, position: number, total: number) =>
        t("reorderMoved", { name, position, total, ...NO_ESCAPE_OPTIONS }),
      dropped: (name: string, position: number, total: number) =>
        t("reorderDropped", { name, position, total, ...NO_ESCAPE_OPTIONS }),
      cancelled: (name: string, position: number, total: number) =>
        t("reorderCancelled", { name, position, total, ...NO_ESCAPE_OPTIONS }),
      saveFailed: (name: string, position: number, total: number) =>
        t("reorderSaveFailed", { name, position, total, ...NO_ESCAPE_OPTIONS }),
      handleColumn: (name: string, position: number, total: number) =>
        t("reorderHandleColumn", {
          name,
          position,
          total,
          ...NO_ESCAPE_OPTIONS,
        }),
      handleLineItem: (name: string, position: number, total: number) =>
        name
          ? t("reorderHandleLineItem", {
              name,
              position,
              total,
              ...NO_ESCAPE_OPTIONS,
            })
          : t("reorderHandleLineItemNameless", { position, total }),
      handleDiscount: (name: string, position: number, total: number) =>
        name
          ? t("reorderHandleDiscount", {
              name,
              position,
              total,
              ...NO_ESCAPE_OPTIONS,
            })
          : t("reorderHandleDiscountNameless", { position, total }),
      rowActionsTip: t("reorderRowActionsTip"),
      lineItemFallback: (position: number) =>
        t("reorderLineItemFallback", { position }),
      discountFallback: (position: number) =>
        t("reorderDiscountFallback", { position }),
      rowActionsName: (name: string, position: number, total: number) =>
        t("reorderRowActionsName", {
          name,
          position,
          total,
          ...NO_ESCAPE_OPTIONS,
        }),
    }),
    [t],
  );
}
